"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roles = exports.RoleHelper = void 0;
var _underscore = _interopRequireDefault(require("underscore"));
var getIn = require('lodash.get');

//Copied here instead of importing api.v2/schemas/roleconstants
var roles = exports.roles = {
  Team: {
    Admin: 'admin'
  },
  Event: {
    ReadOnly: 'readOnly',
    Contributor: 'contributor',
    Admin: 'admin',
    ShowCaller: 'showCaller'
  }
};
roles.Team.All = _underscore["default"].values(roles.Team);
roles.Event.All = _underscore["default"].values(roles.Event);

/**
 * Check if a user has a role
 *
 * @param user
 * @param rolePath //see shared/constants/Permissions
 * @param scope
 */
function has(user, rolePath, scope) {
  if (!user) return false;
  scope = scope || {};
  var roleName = getIn(roles, rolePath),
    entityType = Object.keys(scope)[0],
    entityId = scope[entityType],
    entityRoles = user[entityType + 's'];
  if (!entityRoles) return false;
  var foundIndx = _underscore["default"].findIndex(entityRoles, function (role) {
    //If the entity ID (i.e. teamId or eventId) is not present, then just check for the role name match
    return (!entityId || role[entityType] === entityId) && role['role'] === roleName;
  });
  return foundIndx !== -1;
}

/**
 * Check if a user at at least one of the roles
 *
 * @param user
 * @param roles
 * @returns {boolean}
 */
function hasSome(user, roles) {
  return _underscore["default"].some(roles, function (role) {
    return has(user, role.role, role.scope);
  });
}

/**
 * All roles that have team admin
 *
 * @param teamId
 * @returns {*}
 */
function teamAdminRoles(teamId) {
  return [{
    role: ['Team', 'Admin'],
    scope: {
      team: teamId
    }
  }];
}

/**
 * All roles that have admin (or "greater")
 *
 * @param teamId
 * @param eventId
 * @param includeTeamAdmin
 *
 * @returns {*}
 */

function eventAdminRoles(teamId, eventId, includeTeamAdmin) {
  var adminRoles = [{
    role: ['Event', 'Admin'],
    scope: {
      event: eventId
    }
  }, {
    role: ['Event', 'ShowCaller'],
    scope: {
      event: eventId
    }
  }];
  if (includeTeamAdmin) return adminRoles.concat(teamAdminRoles(teamId));
  return adminRoles;
}

/**
 * All roles that have contributor (or "greater")
 *
 * @param teamId
 * @param eventId
 * @returns {*}
 */
function eventContributorRoles(teamId, eventId) {
  return eventAdminRoles(teamId, eventId).concat({
    role: ['Event', 'Contributor'],
    scope: {
      event: eventId
    }
  });
}

/**
 * Get non-admin roles
 *
 * @param eventId
 * @returns {*[]}
 */
function eventNonAdminRoles(eventId) {
  return [{
    role: ['Event', 'Contributor'],
    scope: {
      event: eventId
    }
  }, {
    role: ['Event', 'ReadOnly'],
    scope: {
      event: eventId
    }
  }];
}

/**
 * Get all event roles
 *
 * @param eventId
 * @returns {*[]}
 */
function anyEventRole(eventId) {
  return [{
    role: ['Event', 'Contributor'],
    scope: {
      event: eventId
    }
  }, {
    role: ['Event', 'ReadOnly'],
    scope: {
      event: eventId
    }
  }, {
    role: ['Event', 'Admin'],
    scope: {
      event: eventId
    }
  }, {
    role: ['Event', 'ShowCaller'],
    scope: {
      event: eventId
    }
  }];
}

/**
 * Check to see if they have an admin role in team
 *
 * @param user
 * @param teamId
 * @returns {boolean}
 */
function hasTeamAdminRole(user, teamId) {
  return hasSome(user, teamAdminRoles(teamId));
}

/**
 * Check to see if they have any role in the event
 *
 * @param user
 * @param teamId
 * @param eventId
 * @returns {boolean}
 */
function hasAnyEventRole(user, teamId, eventId) {
  return hasSome(user, anyEventRole(eventId));
}

/**
 * Check to see if they are a team admin with no event roles
 *
 * @param user
 * @param teamId
 * @param eventId
 * @returns {boolean}
 */
function hasTeamAdminWithoutEventRole(user, teamId, eventId) {
  if (!user || !teamId || !eventId) return false;
  return hasTeamAdminRole(user, teamId) && !hasAnyEventRole(user, teamId, eventId);
}

/**
 * Check to see if they have an admin role in an event
 *
 * @param user
 * @param teamId
 * @param eventId
 * @returns {boolean}
 */
function hasEventAdminRole(user, teamId, eventId) {
  if (hasTeamAdminWithoutEventRole(user, teamId, eventId)) return true;
  return hasSome(user, eventAdminRoles(teamId, eventId));
}

/**
 * Check to see if they have a contributor role in the event
 *
 * @param user
 * @param teamId
 * @param eventId
 * @returns {boolean}
 */
function hasEventContributorRole(user, teamId, eventId) {
  if (hasTeamAdminWithoutEventRole(user, teamId, eventId)) return true;
  return hasSome(user, eventContributorRoles(teamId, eventId));
}

/**
 * Check if they are a show caller
 *
 * @param user
 * @param teamId
 * @param eventId
 * @returns {*}
 */
function hasEventShowCallerRole(user, teamId, eventId) {
  return has(user, ['Event', 'ShowCaller'], {
    event: eventId
  });
}
var RoleHelper = exports.RoleHelper = {
  has: has,
  hasSome: hasSome,
  eventAdminRoles: eventAdminRoles,
  teamAdminRoles: teamAdminRoles,
  eventNonAdminRoles: eventNonAdminRoles,
  hasEventAdminRole: hasEventAdminRole,
  hasEventShowCallerRole: hasEventShowCallerRole,
  hasEventContributorRole: hasEventContributorRole,
  hasTeamAdminRole: hasTeamAdminRole,
  hasAnyEventRole: hasAnyEventRole,
  hasTeamAdminWithoutEventRole: hasTeamAdminWithoutEventRole
};